import { useState, useLayoutEffect, useMemo } from "react";

export function useWindowDimension(targetWidth = 0) {
  const windowExist = typeof window !== undefined;

  const getDimensions = () => {
    const width = windowExist ? window.innerWidth : 0;
    const height = windowExist ? window.innerHeight : 0;

    return {
      width,
      height,
    };
  };

  const [dimensions, setDimensions] = useState(getDimensions());

  useLayoutEffect(() => {
    if (windowExist) {
      const handleResize = () => {
        setDimensions(getDimensions());
      };

      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const isTargetWidth = useMemo(() => dimensions?.width <= targetWidth, [dimensions.width]);

  return isTargetWidth;
}
